import React from 'react';
import { Link, Redirect } from 'react-router-dom';
import configData from "../config.json";

export function HomePage(props) {
    const folderPath = configData.IMAGE_URL + "event/";

    return (
        <div>
            <div className="text-center justify-content-center border-bottom padding-15">
                <div>
                    <h2>BALLOT REGISTRATION</h2>
                    <h2>抽籤登記</h2>
                </div>
            </div>
            <div className="d-flex flex-column text-center justify-content-center border-bottom padding-15">
                <span>Please select the event to register</span>
                <span>請選擇想要登記的活動</span>
            </div>
            {
                props.events
                    .map(c => {
                        var event = Object.keys(c);
                        return (
                            <Link key={event} to={'/event/' + event}>
                                <img alt={event} style={{ "width": "100%", "margin-bottom": "20px"}} src={folderPath + event + "/eventImage.jpg"} />
                            </Link>
                        )
                    })
            }
            {
                props.events.length === 1 && <Redirect to={'/event/' + Object.keys(props.events[0])} />
            }
        </div>
    );
}
